'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/6.
                                          */

// import { addressInfo } from 'redux/modules/publicInfo';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _merchantAuthentication = require('redux/modules/merchantAuthentication');

var _auth = require('redux/modules/auth');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MerchantAuthentication = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    /*
     const promises = [dispatch(load()), dispatch(addressInfo({
     value: '',
     defValue: '',
     firstfilter: '',
     datafilter: ''
     }, 'one'))];
     return Promise.all(promises);*/
    var promises = [];
    promises.push(dispatch((0, _merchantAuthentication.load)()));
    promises.push(dispatch((0, _background.changeHeaderText)('商户认证')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    submitted: state.merchantAuthentication.submitted,
    data: state.merchantAuthentication.data,
    error: state.merchantAuthentication.error
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MerchantAuthentication, _Component);

  function MerchantAuthentication() {
    (0, _classCallCheck3.default)(this, MerchantAuthentication);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MerchantAuthentication).call(this));
  }

  (0, _createClass3.default)(MerchantAuthentication, [{
    key: 'onSubmit',
    value: function onSubmit(submitData) {
      var _props = this.props;
      var dispatch = _props.dispatch;
      var data = _props.data;

      if (dispatch) {
        dispatch((0, _merchantAuthentication.infoSubmit)((0, _extends3.default)({}, data.info[0], submitData), data.orderNumber)).then(function (nextData) {
          dispatch((0, _reactRouterRedux.push)('/publicpayment/' + nextData.payNumber + '/' + nextData.activeId));
        });
      }
    }
  }, {
    key: 'onMerchantTypeChange',
    value: function onMerchantTypeChange(info) {
      var _props2 = this.props;
      var dispatch = _props2.dispatch;
      var data = _props2.data;

      if (dispatch) {
        dispatch((0, _merchantAuthentication.merchantTypeChange)((0, _extends3.default)({}, data.info[0], info), data.orderNumber));
      }
    }
  }, {
    key: 'onVerifyCodeClick',
    value: function onVerifyCodeClick(mobile) {
      var dispatch = this.props.dispatch;

      if (dispatch) {
        dispatch((0, _auth.getCode)(mobile, '1'));
      }
    }
  }, {
    key: 'onAddressChange',
    value: function onAddressChange(value, level) {
      var dispatch = this.props.dispatch;

      if (dispatch) {
        dispatch((0, _merchantAuthentication.addressInfo)({
          value: value,
          defValue: '',
          firstfilter: '',
          datafilter: ''
        }, level));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var data = _props3.data;
      var error = _props3.error;

      var content = error || '请稍候';
      if (data) {
        content = _react2.default.createElement(_components.MerchantAuthenticationForm, { getVerifyCode: this.onVerifyCodeClick.bind(this), initialValues: data.info[0],
          data: data.info[0], addressData: data.addressData,
          onAddressChange: this.onAddressChange.bind(this),
          onMerchantTypeChange: this.onMerchantTypeChange.bind(this),
          onSubmit: this.onSubmit.bind(this) });
      }
      return _react2.default.createElement(
        'div',
        null,
        content,
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return MerchantAuthentication;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object,
  submitted: _react.PropTypes.bool,
  addressData: _react.PropTypes.object,
  error: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = MerchantAuthentication;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MerchantAuthentication/MerchantAuthentication.js
 ** module id = 1496
 ** module chunks = 0
 **/